// About Section
export default function AboutSection({ images }) {
  return (
    <section
      id="about"
      className="pt-8 pb-24 lg:py-32 bg-[#010A13]"
      data-testid="about-section"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <h2 className="font-['Marcellus'] text-3xl sm:text-4xl text-[#F0E6D2] text-center mb-16 tracking-tight">
          About Me
        </h2>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          {/* Avatar */}
          <div className="lg:col-span-5 flex justify-center">
            <div className="gold-frame relative p-1 w-64 h-64 lg:w-80 lg:h-80">
              <div className="hextech-corner hextech-corner-tl" />
              <div className="hextech-corner hextech-corner-tr" />
              <div className="hextech-corner hextech-corner-bl" />
              <div className="hextech-corner hextech-corner-br" />
              <img
                src={images.avatar}
                alt="Profile Avatar"
                className="w-full h-full object-cover"
                data-testid="about-avatar"
              />
            </div>
          </div>

          {/* Bio */}
          <div className="lg:col-span-7">
            <div className="hextech-card p-8">
              <div className="hextech-corner hextech-corner-tl" />
              <div className="hextech-corner hextech-corner-tr" />
              <div className="hextech-corner hextech-corner-bl" />
              <div className="hextech-corner hextech-corner-br" />

              <p className="text-[#A09B8C] leading-relaxed mb-6">
                I’m a Software Developer who loves building things for the web
                and experimenting with new technologies. Most of my experience
                is in JavaScript and Python, and I’ve been exploring cloud
                development with AWS and Azure. I also have a growing interest
                in AI, building applications that leverage APIs and intelligent
                systems to enhance user experiences. I enjoy connecting systems
                together, solving tricky bugs, and making applications faster
                and more reliable.
              </p>
              <p className="text-[#A09B8C] leading-relaxed">
                When I’m not coding, you’ll usually find me exploring new
                technologies, working on side projects, or unwinding with games
                and music.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
